import { Controller } from "@hotwired/stimulus"
import { Formatter } from '../utils/formatter'

export default class extends Controller {
  static targets = ["bucket", "selection", "checkbox", "count", "pageCheckbox"]

  static values = {
    param: String,
    total: { type: Number, default: 0 }
  }

  connect() {
    this.updateCount()
  }

  checkboxTargetConnected(checkbox) {
    checkbox.checked = this.selectedIds.has(checkbox.value)
    this.syncPageCheckbox()
  }

  pageCheckboxTargetConnected() {
    this.syncPageCheckbox()
  }

  toggle(event) {
    const { checked, value } = event.target

    if (checked) {
      this.add(value)
    } else {
      this.remove(value)
    }

    this.updateCount()
    this.syncPageCheckbox()
  }

  togglePage(event) {
    const checked = event.target.checked

    this.checkboxTargets.forEach((checkbox) => {
      if (checkbox.checked === checked) return

      checkbox.checked = checked
      checked ? this.add(checkbox.value) : this.remove(checkbox.value)
    })

    this.updateCount()
  }

  add(id) {
    if (this.selectedIds.has(id)) return

    const input = document.createElement("input")
    input.type = "hidden"
    input.name = this.paramValue
    input.value = id
    input.setAttribute(`data-${this.identifier}-target`, "selection")
    this.bucketTarget.appendChild(input)
  }

  remove(id) {
    this.selectionTargets
      .filter((input) => input.value === id)
      .forEach((input) => input.remove())
  }

  updateCount() {
    if (!this.hasCountTarget) return

    const selected = this.selectedIds.size
    const total = this.formatCount(this.totalValue)
    this.countTarget.textContent = `${this.formatCount(selected)} of ${total} selected`
  }

  syncPageCheckbox() {
    if (!this.hasPageCheckboxTarget || this.checkboxTargets.length === 0) return

    this.pageCheckboxTarget.checked = this.checkboxTargets.every((checkbox) => checkbox.checked)
  }

  formatCount(num) {
    return Formatter.withDelimiters(num)
  }

  get selectedIds() {
    return new Set(
      this.selectionTargets
        .map((input) => input.value)
        .filter(Boolean)
    )
  }
}
